import { ChangeDirection } from '../../types/mutual-fund-detail.types'
import { changeStyle } from '../../constants'

interface ChangeDirectionIndicatorProps {
  changeDirection?: `${ChangeDirection}`
  changeText?: string
  changeDirectionClassName?: string
}

export const ChangeDirectionIndicator = ({
  changeDirection,
  changeText,
  changeDirectionClassName
}: ChangeDirectionIndicatorProps) => {
  if (!changeDirection || !changeText) {
    return null
  }

  return (
    <div
      className={`flex gap-[4px] text-13 font-[500] leading-[120%] ${changeStyle?.[changeDirection]?.className} ${changeDirectionClassName}`}
    >
      <div aria-hidden='true' className={`w-[8px] h-[6px] ${changeDirection === 'NEGATIVE' ? 'mt-2' : 'mt-[7px]'}`}>
        <img src={changeStyle?.[changeDirection]?.icon} alt='' />
      </div>
      <div className='mt-[2px]'>{changeText}</div>
    </div>
  )
}
